module.exports = __webpack_public_path__ + "images/emoji/disappointed_relieved.619acf902f6c9a1006af.png";